import React from 'react';
import { SvgIcon } from '@material-ui/core'

const TrainingCourses = (props) => (
  <SvgIcon
    viewBox="0 0 27.382 36.51"
    {...props}
  >
    <path 
      d="M458.808,275.413a.572.572,0,0,0-.57-.571h-3.423a.572.572,0,0,0-.57.571v3.992h-3.993a.572.572,0,0,0-.57.571V283.4a.572.572,0,0,0,.57.571h3.993v3.993a.572.572,0,0,0,.57.57h3.423a.572.572,0,0,0,.57-.57V283.97H462.8a.573.573,0,0,0,.571-.571v-3.422a.573.573,0,0,0-.571-.571h-3.993Zm10.4-9.556-5.983-5.983a3.426,3.426,0,0,0-2.418-1.006H446.258a3.435,3.435,0,0,0-3.422,3.431v29.657a3.423,3.423,0,0,0,3.422,3.422h20.537a3.424,3.424,0,0,0,3.423-3.422V268.282A3.439,3.439,0,0,0,469.213,265.857Zm-8.122-4.663a1.116,1.116,0,0,1,.527.3l5.983,5.983a1.116,1.116,0,0,1,.3.527h-6.81Zm6.846,30.763a1.145,1.145,0,0,1-1.142,1.141H446.258a1.144,1.144,0,0,1-1.141-1.141V262.3a1.151,1.151,0,0,1,1.141-1.148h12.55v7.423a1.7,1.7,0,0,0,1.712,1.7h7.416Z" 
      transform="translate(-442.836 -258.869)"
    />
  </SvgIcon>
);

export default TrainingCourses;
  
